<template>
    <div  class="col-one-layout" >
       
		<div style="display:flex;width:100vw">
		<article style="width:80vw;margin: auto;text-align:left;font-size:1.3rem">
		 <h2>Wynik został przesłany</h2>
		 
		</article>
		</div>
      
    </div>
</template>

<script> 
        import Localization from '../dao/Localization.js'
        import R from '../static/R.js'

        export default {
            name: 'Contact',
            data() {
                return {
                    msg: "Wynik został przesłany"
                }
            }


        }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
</style>



// WEBPACK FOOTER //
// src/components/SendResultStatus.vue